module.exports = __webpack_public_path__ + "startpage-746fed5a/yaroslav-olieinikov-cf4a15ba29f70a6b835a36c92058c494.jpg";